import { render, staticRenderFns } from "./body.vue?vue&type=template&id=0e0e59fb"
import script from "./body.vue?vue&type=script&setup=true&lang=js"
export * from "./body.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0e59fb')) {
      api.createRecord('0e0e59fb', component.options)
    } else {
      api.reload('0e0e59fb', component.options)
    }
    module.hot.accept("./body.vue?vue&type=template&id=0e0e59fb", function () {
      api.rerender('0e0e59fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tabs/body.vue"
export default component.exports